/**
 * Símbolo da ESTAÇÃO de radiossonda: um marco de lançamento — base no chão,
 * mastro e seta para cima.
 *
 * A primeira versão usava um balão aqui, e era um erro de desenho: o balão de
 * verdade também aparece no mapa, andando pela trilha, então o mapa ficava com
 * DOIS balões por estação — um preso no chão e outro solto, sem nada dizendo
 * qual era qual.
 *
 * Agora só existe um balão no mapa, o que voou. A estação é o lugar de onde
 * ele subiu, e o símbolo diz isso: algo partindo do solo.
 *
 * Unidades: múltiplos do raio base, origem no PONTO DA ESTAÇÃO (a base do
 * mastro), y para CIMA.
 */

/** Meia-largura da base no chão. */
export const W_BASE = 0.8;
/** Altura do mastro. */
export const H_MASTRO = 2.1;
/** Meia-largura da seta. */
export const W_SETA = 0.5;
/** Onde a seta começa, medindo do chão. */
export const Y_SETA = 1.35;

/**
 * Caminho SVG (y para BAIXO, como no canvas e no SVG), com a origem na base.
 * Três traços: chão, mastro e seta.
 */
export const MARCO_SVG =
  `M${-W_BASE} 0L${W_BASE} 0` +
  `M0 0L0 ${-H_MASTRO}` +
  `M${-W_SETA} ${-Y_SETA}L0 ${-H_MASTRO}L${W_SETA} ${-Y_SETA}`;

/** Maior afastamento do símbolo em relação à base, para dimensionar o sprite. */
export const MARCO_EXTENT = H_MASTRO;

let path: Path2D | null = null;
export function marcoPath(): Path2D {
  path ??= new Path2D(MARCO_SVG);
  return path;
}
